import { render, staticRenderFns } from "./BalancesMultiIssue.vue?vue&type=template&id=ed659c6a"
import script from "./BalancesMultiIssue.vue?vue&type=script&lang=js"
export * from "./BalancesMultiIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports